export var CHECK_HOLIDAY = "CHECK_HOLIDAY";
export var CHECK_HOLIDAY_START_LOADER = "CHECK_HOLIDAY_START_LOADER";
export var CHECK_HOLIDAY_STOP_LOADER = "CHECK_HOLIDAY_STOP_LOADER";
